import { Component, Input } from '@angular/core';
import { magicPreviewDummyData } from '../../../classes/company';

@Component({
  selector: 'aira-string',
  templateUrl: './aira-string.component.html',
  styleUrl: './aira-string.component.css',
  standalone: false,
})
export class AiraStringComponent {
  @Input() label = '';
  @Input() value = '';
  @Input() previewOnly: boolean = false;

  stringValue: string;

  ngOnInit() {
    // 1. If in preview mode, set the value first.
    if (this.previewOnly) {
      this.value = magicPreviewDummyData.stringSimple;
    }

    // 2. Safely convert this.value to a string, defaulting to '' if it's null or undefined.
    const valueAsString = this.value?.toString() ?? '';

    // 3. Perform your logic on the safe string.
    this.stringValue =
      valueAsString === 'true'
        ? 'Yes'
        : valueAsString === 'false'
          ? 'No'
          : valueAsString;
  }
}
